'use strict';

import React, { Component, useDebugValue } from 'react';
import { render } from 'react-dom';
import { AgGridReact } from '@ag-grid-community/react';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { MenuModule } from '@ag-grid-enterprise/menu';
// import Consignmentforceclose from '../m';
import Select from 'react-select';
import DrawMap from '../common/drawmap';
import CommentActions from "../layouts/commentsComponent";
import ForceCloseSideBar from "./forceclosuresidebarcomponent";
import { AllModules, GridOptionsWrapper } from '@ag-grid-enterprise/all-modules';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import MarkDeliver from "../layouts/markDeliveredButton.js";
import '@ag-grid-community/core/dist/styles/ag-grid.css';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import ConsignmentActions from '../manage/ConsignmentActionsComponent';
import CountUp from 'react-countup';
import SweetAlert from 'react-bootstrap-sweetalert';
import CSVFileValidator from 'csv-file-validator';
import Consignmentforceclose from '../manage/consignmentforceclose';
import UpdateButton from "./updatelmstates";
import * as Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import CellGraphComponent from './cellGraphComponent';
import $ from 'jquery';

import { verifyext } from "../common/verifyext";
import CheckBox from '../superadmin/checkbox';
import { LoadingPortContext, resolvePageAccess } from '../../context/LoadingPortContext';

// const $ = window.$;
window.jQuery = $;
window.$ = $;
var redirectURL = require('../redirectURL');
var moment = require('moment');
var filecontent = "";
var googleAnalytics = require("../common/googleanalytics");
var CELL_DIMENSION_SIZE = 90;




export default class LmLoadManager extends Component {
    static contextType = LoadingPortContext;

    constructor(props, context) {
        super(props, context);
        this._lastLoadingPortCode = context ? context.loading_port_code : null;
        this.state = {
            modules: AllModules,
            defaultColDef: {
                sortable: true,
                filter: true,
                editable: true,
            },
            eventAction: null,
            show: false,
            frameworkComponents: {
                consignmentforceclose: Consignmentforceclose,
                consignmentActions: ConsignmentActions,
                UpdateButton: UpdateButton,
                MarkDeliver: MarkDeliver,
                commentActions: CommentActions
            },
            modified_by: "",
            basicTitle: '',
            reasonforceclose: "",
            bulkslide: "",
            file: "",
            uploadFile: "",
            basicType: "default",
            loadshow: 'show-n',
            forceCloseRowNode: "",
            forceclosedata: "",
            csvcontent: "",
            sliderForceCloseTranslate: "",
            overly: '',
            rowData: [],
            bulkslide: "",
            showDiv: "",
            uploadDivWidth: "",
            mapinfo: "",
            dealer: "",
            sliderCommentTranslate: "",
            commentsRowData: "",
            consignment_code: "",
            sliderRouteTranslate: "",
            maptruckno: "",
            routeTruck: "",
            rownode: "",
            googelRoutes: "",
            file: "",
            rowSelection: 'multiple',
            sliderForceCloseTranslate: "",
            maptruckno: "",
            rowModelhighchartoptionsType: 'enterprise',
            rowGroupPanelShow: 'always',
            statusBar: {
                statusPanels: [
                    {
                        statusPanel: "agTotalAndFilteredRowCountComponent",
                        align: "left"
                    },
                    {
                        statusPanel: "agTotalRowCountComponent",
                        align: "center"
                    },
                    { statusPanel: "agFilteredRowCountComponent" },
                    { statusPanel: "agSelectedRowCountComponent" },
                    { statusPanel: "agAggregationComponent" }
                ]
            },
            paginationPageSize: 200,
            geofencelist: [],
            geoFenceData: "",
            sideBar: {
                toolPanels: [
                    {
                        id: "columns",
                        labelDefault: "Columns",
                        labelKey: "columns",
                        iconKey: "columns",
                        toolPanel: "agColumnsToolPanel"
                    },
                    {
                        id: "filters",
                        labelDefault: "Filters",
                        labelKey: "filters",
                        iconKey: "filter",
                        toolPanel: "agFiltersToolPanel"
                    }
                ]
            },
            animateRows: true,
            dept_code: "",
            pagetitle: "",
            markDeliverRowNode: "",
            markDeliverData: "",
            sliderMarkDeliverTranslate: "",
            csvData: 0,
            overly: "show-n",
            loadshow: "show-n",
            holidayEvents: [],
            showCalendar: "show-m",
            showGridData: "show-m",
            loadFile: "",
            processErrMsg: "",
            processErrShow: "",
            transactionId: "",
            droppedList: [],
            statusCode: "",
            comp_code: "",
            lpNames: [],
            loading_port_code: "",
            data_type: 1,
            regularActive: "activet",
            truckActive: "",
            courierActive: "", hubActive: "",
            checkCount: 1,
            betaCheck: 0,
            alphaCheck: 0,
            deltaCheck: 0,
            automatedCheck: 0,
            flag: 0,
            showMoreInfo: false,
            selectedFileName: "",
            vipCheck: 0,
            isDragging: false,
            isGeneratingLoad: false,
            //components : {datepicker:getDatePicker()}
        }
        this.onLoadPageData = this.onLoadPageData.bind(this);
        this.changeFileHandler = this.changeFileHandler.bind(this);
        this.uploadBulkFormHandler = this.uploadBulkFormHandler.bind(this);
        this.onCellClicked = this.onCellClicked.bind(this)
    }

    componentDidMount() {
        loadDateTimeScript();
        this.pageAccess();
    }

    async pageAccess() {
        this.setState({
            loadshow: 'show-m',
            overly: 'show-m',
        })
        var currentUrl = this.props.match.path;
        var resolved = await resolvePageAccess(currentUrl, this.context);
        if (!resolved) {
            // No access (already alerted+redirected), empty port list, or a logged request error.
            this.setState({ loadshow: 'show-n', overly: 'show-n' });
            return;
        }
        this._lastLoadingPortCode = resolved.loading_port_code;
        this.setState({
            pageAccess: resolved.pageAccess,
            loading_port_code: resolved.loading_port_code,
            comp_code: resolved.comp_code,
            lpNames: resolved.lpNames,
            loadshow: 'show-n',
            overly: 'show-n',
        });
        await this.onLoadPageData();
    }

    onLoadPageData() {
        var loading_port_code = this.state.loading_port_code;
        var data_type = this.state.data_type;
        var params = {
            loading_port_code: loading_port_code,
            data_type: data_type, hub_vehicle: this.state.hubActive == "activet" ? 1 : 0
        }
        redirectURL.post("/lmconsignees/getLmVehicleCapacity", params).then((response) => {
            //console.log(response.data);
            this.setState({
                rowData: response.data
            })
        }).catch((e) => {
            console.log(e);
        })
    }

    onGridReady = params => {
        this.gridApi = params.api;
        //console.log("Grid is: ", params);
        this.gridColumnApi = params.columnApi;
    };
    onGridState = () => {
        //console.log(this.gridApi);

        /*Get  Current Columns State and Store in this.colState */
        this.colState = this.gridColumnApi.getColumnState();

        /*Get Current RowGroup Columns State and Store in this.rowGroupState */
        this.rowGroupState = this.gridColumnApi.getRowGroupColumns();

        /*Get Current Pivot Columns State and Store in this.pivotColumns, 
        * User should enable the Pivot mode.*/
        this.pivotColumns = this.gridColumnApi.getPivotColumns();

        /*Get Current Filter State and Store in window.filterState */
        window.filterState = this.gridApi.getFilterModel();
        this.gridApi.setFilterModel(window.filterState);
    }



    closeAlert = () => {
        var type = this.state.basicType;
        this.setState({
            show: false
        });
        if (type === "success") {
            window.location.href = "/lmloadsummary";
        }
    }

    onCellClicked(e) {
        if (e.colDef.field == "container_no") {
            console.log(e.data.container_no);
        }
    }

    onClickHideAll() {
        if (this.state.isGeneratingLoad) {
            return;
        }
        this.setState({
            loadshow: 'show-n',
            overly: 'show-n',
            bulkslide: "",

        });
        $("#uploadFile").val("");
        $("#notify_email").val("");
    }
    updateLmStates(params) {
        //console.log(params);
        if (params.vehicle_cap != '' && params.vehicle_cap != undefined) {
            redirectURL.post("/lmconsignees/savelmvehiclecapacity", params).then((response) => {
                console.log(response);
                if (response.data.message == "Success") {
                    this.setState({
                        basicTitle: "Updated Successfully.",
                        basicType: "success",
                        show: true
                    })
                    window.location.reload();
                }
                else {
                    this.setState({
                        basicTitle: "Failed to update.",
                        basicType: "warning",
                        show: true
                    })
                }
            })
        }
        else {
            this.setState({
                basicTitle: "Fields Should not be Empty.",
                basicType: "warning",
                show: true
            })
        }
    }
    addNewRow() {
        // console.log(this.gridApi);
        this.gridApi.insertItemsAtIndex(0, [{ vehicle_cap: "", min_capacity_cmt: "", max_capacity_cmt: "", min_courier: "", nodes_per_truck: "", allowed_distance: "" }])
        // this.gridApi.updateRowData({add:[{holiday_date:"",holiday_name:""}]});
    }
    showGrid() {
        this.setState({
            showCalendar: "show-n",
            showGridData: "show-m"
        })
    }

    showBulkUpload() {
        this.setState({
            overly: "show-m",
            bulkslide: "slider-translate-40p"
        })
        var errEl = document.getElementById("inValidDataInfo");
        if (errEl) { errEl.innerHTML = ""; errEl.style.display = "none"; }
    }
    resetUpload = () => {
        if (this.state.isGeneratingLoad) {
            return;
        }
        this.setState({
            bulkslide: '',
            overly: 'show-n',
            loadFile: '',
            selectedFileName: ""
        });
        $("#uploadFile").val("");
        $("#notify_email").val("");
        var errEl = document.getElementById("inValidDataInfo");
        if (errEl) { errEl.innerHTML = ""; errEl.style.display = "none"; }
        //document.getElementById("upform").reset();
    }
    fixProcess = () => {
        this.setState({
            processErrMsg: "",
            processErrShow: 0,
            loadFile: '',
            selectedFileName: ""
        });
        $("#uploadFile").val("");
        $("#notify_email").val("");

        let ele = document.getElementById("inValidDataInfo");
        if (ele) { ele.innerHTML = ""; ele.style.display = "none"; }
        //document.getElementById("upform").reset();
    }
    ignoreProcessError = () => {
        this.setState({
            isGeneratingLoad: true,
        });
        var transactionId = this.state.transactionId;
        var loading_port_code = this.state.loading_port_code;
        var betaCheck = this.state.betaCheck;
        var alphaCheck = this.state.alphaCheck
        var deltaCheck = this.state.deltaCheck
        var automatedCheck = this.state.automatedCheck
        var email = localStorage.getItem('email')
        console.log("transactionId", transactionId)
        var params = {
            transactionId: transactionId,
            loading_port_code: loading_port_code,
            data_type: this.state.data_type,
            betaCheck: betaCheck,
            alphaCheck: alphaCheck,
            deltaCheck: deltaCheck,
            automatedCheck: automatedCheck,
            vipCheck: this.state.vipCheck,
            hubHoldCheck: this.state.hubHoldCheck,
            email: email
        }
        console.log(params, "497")
        redirectURL.post("/lmconsignees/generateLoadByTransactionId", params).then((response) => {
            //console.log(response.data,"response")
            var statusCode = response.data.status;
            if (statusCode == 0 || statusCode == 1) {
                this.setState({
                    basicTitle: response.data.message,
                    basicType: "success",
                    show: true,
                    processErrMsg: "",
                    processErrShow: 0,
                    isGeneratingLoad: false,
                    bulkslide: "",
                    overly: 'show-n',
                });
            }
            else {
                this.setState({
                    processErrMsg: response.data.message,
                    processErrShow: 1,
                    transactionId: response.data.transactionId,
                    isGeneratingLoad: false,
                });
            }
            //window.location.reload();
        })
            .catch((e) => {
                console.log(e, "ignoreProcessError");
                this.setState({
                    basicTitle: "Error Processing File",
                    basicType: "error",
                    show: true,
                    isGeneratingLoad: false,
                });
            })
    }

    changeFileHandler = async (e) => {
        console.log(e);
        this.setState({
            loadFile: e.target.files[0],
            selectedFileName: e.target.files[0] ? e.target.files[0].name : ""
        });

        this.changeCSVFileHandler(e)

        var check = verifyext(e.target.files[0].name);
        //console.log("Check ", check)
        if (check == true) {
            if (e.target.files[0].type == '' || e.target.files[0].type == 'text/csv' || e.target.files[0].type == 'application/vnd.ms-excel') {
                // console.log(fileData);
                // console.log(typeof(fileData))

            }
            else {
                e.target.value = null;
                this.setState({
                    uploadFile: '',
                    show: true,
                    basicType: 'danger',
                    basicTitle: 'Please upload file having extensions .csv only.',
                });
            }
        }
        else {
            e.target.value = null;
            this.setState({
                uploadFile: '',
                show: true,
                basicType: 'danger',
                basicTitle: 'Please upload file having extensions .csv only.',
            });
        }

    }

    uploadBulkFormHandler(event) {
        event.preventDefault();
        if (this.state.isGeneratingLoad) {
            return;
        }
        var flag = this.state.flag
        let saveData = new FormData();
        var beta_Check = $("#betaChechkbox").is(':checked')
        var betaCheck = 0
        if (beta_Check == true) {
            betaCheck = 1
        } else {
            betaCheck = 0
        }
        var alpha_Check = $("#alphaCheckkbox").is(':checked')
        var alphaCheck = 0
        if (alpha_Check == true) {
            alphaCheck = 1
        } else {
            alphaCheck = 0
        }
        var delta_Check = $("#deltacheckbox").is(':checked')
        var deltaCheck = 0
        if (delta_Check == true) {
            deltaCheck = 1
        } else {
            deltaCheck = 0
        }
        var automated_Check = $("#automatedcheckbox").is(':checked')
        var automatedCheck = 0
        if (automated_Check == true) {
            automatedCheck = 1
        } else {
            automatedCheck = 0
        }
        var vip_Check = $("#vipcheckbox").is(':checked')
        var vipCheck = vip_Check == true ? 1 : 0
        var hubHoldCheck = $("#hubholdcheckbox").is(':checked') == true ? 1 : 0
        if (flag == 0) {
            saveData.append("loadFile", this.state.loadFile);
            var notify_email = $("#notify_email").val();
            saveData.append("notify_email", notify_email);
            var loading_port_code = this.state.loading_port_code;
            saveData.append("loading_port_code", loading_port_code)
            saveData.append("betaCheck", betaCheck)
            saveData.append("alphaCheck", alphaCheck)
            saveData.append("deltaCheck", deltaCheck)
            saveData.append("automatedCheck", automatedCheck)
            saveData.append("vipCheck", vipCheck)
            saveData.append("hubHoldCheck", hubHoldCheck)
            saveData.append("data_type", this.state.data_type)
            saveData.append("comp_code", this.state.comp_code)
            saveData.append("user_name", localStorage.getItem('username'))
            saveData.append("email", localStorage.getItem('email'))
            saveData.append("staff_id", localStorage.getItem('staff_id'))
            saveData.append("user_department", localStorage.getItem('lm_department'))
            saveData.append("designation", localStorage.getItem('designation'))
            saveData.append("user_role", localStorage.getItem('roles'))
            console.log(saveData, "623");
            this.setState({
                isGeneratingLoad: true,
                checkCount: 1,
                betaCheck: betaCheck,
                alphaCheck: alphaCheck,
                deltaCheck: deltaCheck,
                automatedCheck: automatedCheck,
                vipCheck: vipCheck,
                hubHoldCheck: hubHoldCheck
            });
            redirectURL.post("/lmconsignees/generateLoad", saveData).
            then((response) => {
                
                console.log(response, "responseFromProcess")
                var statusCode = response.data.status;
                if (statusCode == 8) {
                    this.setState({
                        processErrMsg: response.data.message,
                        processErrShow: 1,
                        transactionId: response.data.transactionId,
                        droppedList: response.data.droppedList,
                        statusCode: statusCode,
                        loadshow: 'show-n',
                        overly: 'show-n',
                        isGeneratingLoad: false,
                    });
                }
                else if (statusCode > 3 && statusCode != 8) {
                    if (statusCode == 11) {
                        var processMsg = "Use the standard input data file template for uploading loads";
                    }
                    else {
                        var processMsg = response.data.message;
                    }
                    this.setState({
                        processErrMsg: response.data.message,
                        processErrShow: 1,
                        transactionId: response.data.transactionId,
                        statusCode: statusCode,
                        loadshow: 'show-n',
                        overly: 'show-n',
                        isGeneratingLoad: false,
                    });
                }
                else {
                    this.checkTransactionStatus(response.data.transactionId);
                    // this.setState({                    
                    //     basicTitle : response.data.message,
                    //     basicType : "success",
                    //     show : true,
                    //     loadshow:'show-n',
                    //     overly:'show-n',
                    //     bulkslide:"",
                    // });
                }
                //window.location.reload();
            })
                .catch((e) => {
                    console.log(e, "uploadBulkFormHandler");
                    this.setState({
                        basicTitle: "Error in uploading file",
                        basicType: "error",
                        show: true,
                        loadshow: 'show-n',
                        overly: 'show-n',
                        isGeneratingLoad: false,
                    });
                })
        }
        else {
            this.setState({
                basicTitle: "Please upload the file",
                basicType: "warning",
                show: true,
            })
        }
    };

    checkTransactionStatus = (transactionId) => {
        var query = {
            transaction_id: transactionId
        }
        redirectURL.post("/lmconsignees/checkTransactionStatus", query).then((response) => {
            console.log(response, "responseFromcheckTransactionStatus")
            var statusCode = response.data.status;
            if (statusCode == 8) {
                this.setState({
                    processErrMsg: response.data.message,
                    processErrShow: 1,
                    transactionId: response.data.transactionId,
                    droppedList: response.data.droppedList,
                    statusCode: statusCode,
                    loadshow: 'show-n',
                    overly: 'show-n',
                    isGeneratingLoad: false,
                });
            }
            else if (statusCode == 15) {
                // 15 = SOLVER_PROCESSING_PLAN. The engine sets this in exactly one place —
                // verify_dealer_data, right AFTER input validation passes with no invalid /
                // dropped dealers. So by the time we see 15 the Fix & Re-upload / Ignore &
                // Continue screen can no longer appear, and the only thing left is the solve
                // (which is minutes, not seconds). Release the user here with "File is
                // processing" instead of holding the upload spinner for the whole plan — the
                // result is picked up from the Load Summary screen.
                this.setState({
                    basicTitle: "File is processing. The plan will appear in Load Summary once completed.",
                    basicType: "success",
                    show: true,
                    loadshow: 'show-n',
                    overly: 'show-n',
                    bulkslide: "",
                    isGeneratingLoad: false,
                });
            }
            else if (statusCode == 0) {
                // 0 = queued / engine has not finished validating yet, so an invalid-input
                // outcome (status 8) is still possible — keep polling until the engine moves
                // the transaction off 0. generateLoad is fire-and-forget, so poll every 5s
                // well past the old 3-try limit instead of giving up with "processing".
                var checkCount = this.state.checkCount;
                var updatedCnt = parseInt(checkCount) + 1;
                this.setState({
                    checkCount: updatedCnt
                });
                if (updatedCnt < 240) {   // ~20 min at 5s interval
                    setTimeout(() => {
                        this.chkStatus(response.data.transactionId);
                    }, 5000);
                }
                else {
                    this.setState({
                        basicTitle: "File is processing",
                        basicType: "success",
                        show: true,
                        loadshow: 'show-n',
                        overly: 'show-n',
                        bulkslide: "",
                        isGeneratingLoad: false,
                    });
                }
            }
            else if (statusCode > 3) {
                this.setState({
                    processErrMsg: response.data.message,
                    processErrShow: 1,
                    transactionId: response.data.transactionId,
                    statusCode: statusCode,
                    loadshow: 'show-n',
                    overly: 'show-n',
                    isGeneratingLoad: false,
                });
            }
            else {
                // 1 / 2 / 3 -> completed
                this.setState({
                    basicTitle: response.data.message,
                    basicType: "success",
                    show: true,
                    loadshow: 'show-n',
                    overly: 'show-n',
                    bulkslide: "",
                    isGeneratingLoad: false,
                });
            }
        }).catch((e) => {
            // Transient error while polling — retry rather than failing the whole flow.
            var checkCount = this.state.checkCount;
            var updatedCnt = parseInt(checkCount) + 1;
            this.setState({ checkCount: updatedCnt });
            if (updatedCnt < 240) {
                setTimeout(() => {
                    this.chkStatus(transactionId);
                }, 5000);
            }
            else {
                this.setState({
                    basicTitle: "File is processing",
                    basicType: "success",
                    show: true,
                    loadshow: 'show-n',
                    overly: 'show-n',
                    isGeneratingLoad: false,
                });
            }
        });
    }

    chkStatus = (transactionId) => {
        this.checkTransactionStatus(transactionId);
    }

    onSelectBulkPlants = (location) => {
        var plants = [];
        try {
            location.map(function (e) {
                plants.push(e.value);
            })
            console.log(plants);
            this.setState({
                plant_name: plants
            });
        }
        catch (e) {
            console.log(e);
        }

    }

    componentDidUpdate() {
        if (this.context && this.context.loading_port_code !== this._lastLoadingPortCode) {
            this._lastLoadingPortCode = this.context.loading_port_code;
            this.onGlobalPortChange();
        }
    }
    onGlobalPortChange = async () => {
        var selectedPlant = this.context.loading_port_code;
        if (!selectedPlant || !this.state.lpNames.some(each => each.loading_port_code == selectedPlant)) {
            // Not a valid port for this screen - keep this screen's own selection, don't refetch.
            return;
        }
        await this.pageAccess();
    }
    async onClickTab(data_type, type) {
        var regularActive = "";
        var truckActive = "";
        var courierActive = "";
        var hubActive = "";
        if (data_type == 1 && type !== "hub") {
            regularActive = "activet";
        }
        else if (data_type == 2) {
            truckActive = "activet";
        }
        else if (data_type == 1 && type === "hub") {
            hubActive = "activet";
        }
        else {
            courierActive = "activet";
        }
        await this.setState({
            data_type: data_type,
            regularActive: regularActive,
            truckActive: truckActive,
            courierActive: courierActive,
            hubActive: hubActive
        
        });
        await this.onLoadPageData();
    }

    changeCSVFileHandler = async (e) => {
        document.getElementById("generateLoadBtn").type = "button";
        document
            .getElementById("generateLoadBtn")
            .classList.remove("btn-success");
        document
            .getElementById("generateLoadBtn")
            .classList.add("btn-dark");
        const config = {
            headers: [
                {
                    name: "Dealer Code",
                    inputName: "dealer_code",
                },
                {
                    name: "Dealer Demand",
                    inputName: "dealer_demand",
                },
                {
                    name: "Order Date(dd-mm-yyyy)",
                    inputName: "order_date",
                },
                {
                    name: "Dealer Category",
                    inputName: "dealer_category",

                },

                {
                    name: "Order Category",
                    inputName: "order_category",
                },
                {
                    name: "Order Type",
                    inputName: "order_type",
                },
                {
                    name: "Pick Ticket",
                    inputName: "pick_ticket",
                    required: true,
                    requiredError: function (headerName, rowNumber, columnNumber) {
                        return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`;
                    },
                    unique: true,
                    uniqueError: function (headerName, rowNumber, columnNumber) {
                        return `${headerName} is not unique in the ${rowNumber} row / ${columnNumber} column`;
                    },
                },
                {
                    name: "OD Category",
                    inputName: "od_category",
                },
                {
                    name: "H Category",
                    inputName: "h_category",
                },
                {
                    name: "Floor",
                    inputName: "floor",
                }
            ],
        };

        var data = CSVFileValidator(e.target.files[0], config)
            .then((csvData) => {
                let blankrows = []
                let excelData = csvData.data.map((itm, idx) => {
                    if (itm.dealer_code == '') {
                        blankrows.push(idx + 2)
                    }
                })

                let errors = csvData.inValidMessages
                errors = errors.filter(error => {
                    return !blankrows.some(row => error.includes(`${row} row`));
                });
                console.log(blankrows, 'blank', errors)
                let element = document.getElementById("inValidDataInfo");
                element.innerHTML = "";
                element.style.display = "none";
                if (errors.length > 0) {
                    $("#uploadFile").val("");
                    document.getElementById("generateLoadBtn").type = "button";
                    document
                        .getElementById("generateLoadBtn")
                        .classList.remove("btn-success");
                    document
                        .getElementById("generateLoadBtn")
                        .classList.add("btn-dark");

                    element.style.display = "block";
                    element.innerHTML = "<div style='position:sticky;top:0;display:flex;align-items:center;gap:8px;padding:10px 14px;background:#ffebee;border-bottom:1px solid #ffcdd2;margin:0px;border-radius:8px 8px 0 0;'><span style='font-size:15px;'>⚠️</span><span style='font-weight:700;font-size:12px;color:#b71c1c;'>" + errors.length + " Validation Error" + (errors.length > 1 ? "s" : "") + " Found</span></div><div>";
                    errors.map((item, idx) => {
                        element.innerHTML += "<div style='display:flex;align-items:flex-start;gap:10px;padding:7px 8px;margin:6px 8px;background:#fff;border:1px solid #ffcdd2;border-radius:6px;'><span style='min-width:22px;height:22px;background:#e53935;color:#fff;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;flex-shrink:0;'>" + (idx + 1) + "</span><span style='font-size:12px;color:#333;line-height:1.5;'>" + item + "</span></div>";
                        return "";
                    });
                    element.innerHTML += "</div>";
                    this.setState({
                        flag: 1,
                    });
                } else {
                    document.getElementById("generateLoadBtn").type = "submit";
                    document
                        .getElementById("generateLoadBtn")
                        .classList.remove("btn-dark");
                    document.getElementById("generateLoadBtn").classList.add("btn-success");
                    element.innerHTML = "";
                    element.style.display = "none";
                    this.setState({
                        loadFile: e.target.files[0],
                        flag: 0
                    });
                }
            })
            .catch((err) => { });
    }; 

    toggleMoreInfo = () => {
        this.setState((prevState) => ({ showMoreInfo: !prevState.showMoreInfo }));
    };

    handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ isDragging: true });
    }

    handleDragLeave = (e) => {
        e.preventDefault();
        this.setState({ isDragging: false });
    }

    handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ isDragging: false });
        const file = e.dataTransfer.files[0];
        if (!file) return;
        var check = verifyext(file.name);
        if (check == true && (file.type == '' || file.type == 'text/csv' || file.type == 'application/vnd.ms-excel')) {
            try {
                const dt = new DataTransfer();
                dt.items.add(file);
                document.getElementById('uploadFile').files = dt.files;
            } catch (err) {}
            this.setState({ loadFile: file, selectedFileName: file.name });
            this.changeCSVFileHandler({ target: { files: [file] } });
        } else {
            this.setState({
                show: true,
                basicType: 'danger',
                basicTitle: 'Please upload file having extensions .csv only.',
                selectedFileName: "",
                loadFile: ""
            });
        }
    }

    render() {

        var columnwithDefs = [
            {
                headerName: "Vehicle Type",
                field: "vehicle_cap",
                width: 180,
                filter: true,
                resizable: true,
                editable: false,
            },
            {
                headerName: "Zone",
                field: "zone",
                width: 150,
                filter: true,
                resizable: true,
                editable: false,
                valueGetter: (params) => {
                    // if (this.state.hubActive == "activet") return "ALL";
                    return params.data.zone || "";
                }
            },
            {
                headerName: "Vehicle Capacity (CMT)",
                field: "vehicle_capacity",
                width: 180,
                filter: true,
                resizable: true,
                // editable: false,
            },
            {
                headerName: "Min Capacity (CMT)",
                field: "min_capacity_cmt",
                width: 160,
                filter: true,
                resizable: true,
                editable: false
            },

            {
                headerName: "Max Capacity (CMT)",
                field: "max_capacity_cmt",
                width: 160,
                filter: true,
                resizable: true,
                editable: false
            },
            {
                headerName: "Min CMT per Consignee",
                field: "min_courier",
                width: 160,
                filter: true,
                resizable: true,
                editable: false
            },
            {
                headerName: "Max CMT Per Consignee",
                field: "max_consignee_cmt",
                width: 180,
                filter: true,
                resizable: true,
                editable: false
            },
            {
                headerName: "Minimum Nodes",
                field: "minimum_nodes",
                width: 150,
                filter: true,
                resizable: true,
                editable: false
            },
            {
                headerName: "Maximum Nodes",
                field: "nodes_per_truck",
                width: 150,
                filter: true,
                resizable: true,
                editable: false
            },
            {
                headerName: "Max Distance",
                field: "allowed_distance",
                width: 150,
                filter: true,
                resizable: true,
                editable: false
            },
            // {
            //     headerName: "Deviation Distance (%)",
            //     field: "deviation_allowed",
            //     width:180,
            //     filter: true,
            //     resizable: true,
            //     editable:false
            // },
            {
                headerName: "Telescopic Route",
                field: "telescopic_route",
                width: 180,
                filter: true,
                resizable: true,
                editable: false, hide: true,
                valueGetter: function (params) {
                    if (params.data.telescopic_route == 1) {
                        return "Enabled";
                    }
                    else {
                        return "Disabled";
                    }
                }
            },

            {
                headerName: "Recommendation (CMT)",
                field: "recommendation_cmt",
                width: 160,
                filter: true,
                resizable: true,
                editable: false
            },
            // {
            //     pinned:"left",
            //     headerName : "Update",
            //     field:"_id",
            //     width:150,
            //     resizable : true,
            //     editable : false,
            //     cellRendererSelector:function(params){       
            //         var rendComponent = {
            //             component: 'UpdateButton'
            //         };
            //         return rendComponent;
            //     },
            // }
        ]

        var columnwithDefsForDropped = [
            {
                headerName: "Dealer",
                field: "dealer_code",
                width: 130,
                filter: true,
                resizable: true,
                editable: false,
            },
            {
                headerName: "Demand",
                field: "demand",
                width: 130,
                filter: true,
                resizable: true,
                editable: false
            },
            {
                headerName: "Remarks",
                field: "remarks",
                width: 200,
                filter: true,
                resizable: true,
                editable: false
            },
        ]
        var userroles = localStorage.getItem("roles")
        return (
            <div class="container-fluid" style={{ height: "100%" }}>
                <SweetAlert
                    show={this.state.show}
                    type={this.state.basicType}
                    title={this.state.basicTitle}
                    onConfirm={this.closeAlert}
                >
                </SweetAlert>

                <div className="row" style={{ marginBottom: "10px" }}>
                    <div className="col-sm-12">
                        <ul
                            style={{
                                display: "inline-flex",
                                flexWrap: "wrap",
                                padding: "4px",
                                margin: 0,
                                listStyle: "none",
                                gap: "4px",
                                backgroundColor: "#ffffff",
                                borderRadius: "10px",
                                boxShadow: "0 1px 3px rgba(0,0,0,0.15)"
                            }}
                        >
                            {[
                                { onClick: this.onClickTab.bind(this, 1, "hub"), label: "Hub", active: this.state.hubActive },
                                { onClick: this.onClickTab.bind(this, 1, ""), label: "Regular", active: this.state.regularActive },
                                { onClick: this.onClickTab.bind(this, 3, ""), label: "Dedicated", active: this.state.courierActive },
                                { onClick: this.onClickTab.bind(this, 2, ""), label: "Surface Courier", active: this.state.truckActive },
                            ].map(({ onClick, label, active }, idx) => {
                                var isActive = active == "activet";
                                return (
                                    <li key={idx} onClick={onClick} style={{ listStyle: "none" }}>
                                        <button
                                            type="button"
                                            style={{
                                                whiteSpace: "nowrap",
                                                border: "none",
                                                outline: "none",
                                                borderRadius: "999px",
                                                padding: "8px 18px",
                                                fontSize: "13px",
                                                fontWeight: isActive ? 600 : 500,
                                                cursor: "pointer",
                                                transition: "all 0.2s ease",
                                                backgroundColor: isActive ? "#1976d2" : "transparent",
                                                color: isActive ? "#fff" : "#555",
                                                boxShadow: isActive ? "0 1px 4px rgba(25,118,210,0.4)" : "none"
                                            }}
                                        >
                                            {label}
                                        </button>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>

                <div className="card col-xl-12" style={{ borderRadius: "10px", boxShadow: "0 1px 4px rgba(0,0,0,0.08)", height: "90%", display: "flex", flexDirection: "column", minHeight: 0 }}>
                    <div className="d-flex justify-content-between align-items-center" style={{ flexWrap: "wrap", gap: "10px", padding: "14px 18px", marginBottom: "10px", flexShrink: 0 }}>
                        <div className="d-flex align-items-center" style={{ gap: "14px" }}>
                            <div style={{ width: "5px", height: "26px", background: "linear-gradient(180deg,#1976d2,#42a5f5)", borderRadius: "3px", flexShrink: 0 }}></div>
                            <h5 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#1a237e", letterSpacing: "0.2px" }}>Configuration</h5>
                        </div>
                        <div className="d-flex align-items-center" style={{ flexWrap: "wrap", gap: "8px" }}>
                            {(this.state.pageAccess != 2) ?
                                <a href="/lmvehiclecapacity" className="pill-btn pill-btn-danger">Edit Config</a>
                                : ""}
                            {(this.state.pageAccess != 2) ?
                                <button className="pill-btn pill-btn-info" onClick={this.showBulkUpload.bind(this)}>Plan New Dispatch</button>
                                : ""}
                        </div>
                    </div>
                    {/* {(this.state.lpNames.length > 0) ?
                        <div className="row col-xl-12 col-lg-12" style={{ marginTop: "2%" }}>
                            <div className="col-xl-12 col-lg-12">
                                {this.state.lpNames.length == 1 ?
                                    <span style={{ fontSize: "16px" }}>Loading Plant : {(this.state.lpNames[0].loading_port)}</span>
                                    :
                                    <span style={{ fontSize: "16px" }}>Loading Plant :
                                        <select id="loadingPlant" onChange={this.onChangeLoadingPlant.bind(this)}>
                                            {(this.state.lpNames).map(function (obj) {
                                                return <option value={obj.loading_port_code}>{obj.loading_port}</option>
                                            })}
                                        </select>
                                    </span>
                                }
                            </div>
                        </div>
                        : ""} */}
                    <div className="col-xl-12 col-lg-12" style={{ flex: 1, width: "100%", display: "flex", flexDirection: "column", minHeight: 0 }}>
                        {/* <div id="myGrid" style={{ width: "100%", height: "478px" }} className={"ag-theme-balham " + this.state.showGridData}>
                            <AgGridReact
                                modules={this.state.modules}
                                columnDefs={columnwithDefs}
                                defaultColDef={this.state.defaultColDef}
                                rowData={this.state.rowData}
                                enableCharts={false}
                                // autoGroupColumnDef={this.state.autoGroupColumnDef}
                                onGridReady={this.onGridReady}
                                onGridState={this.onGridState}
                                frameworkComponents={this.state.frameworkComponents}
                                statusBar={this.state.statusBar}
                                sideBar={this.state.sideBar}
                                stopEditingWhenGridLosesFocus={true}
                                paginationPageSize={this.state.paginationPageSize}
                                pagination={true}
                                gridOptions={{
                                    context: { componentParent: this }
                                }}
                                // components={this.state.components}
                                enableRangeSelection={true}
                            //onCellClicked={this.onCellClicked}
                            // onCellEditingStopped={this.onCellUpdateData.bind(this)}
                            />
                        </div> */}
                        <div className="ag-theme-balham grid-wrapper mb-3" style={{ flex: 1, minHeight: 0 }}>
                            <AgGridReact
                                // ref={this.gridRef}
                                modules={this.state.modules}
                                rowData={this.state.rowData}
                                columnDefs={columnwithDefs}
                                defaultColDef={{
                                    sortable: true,
                                    filter: true,
                                    floatingFilter: true
                                }}

                                statusBar={{
                                    statusPanels: [
                                        { statusPanel: "agSelectedRowCountComponent", align: "left" },
                                        { statusPanel: "agFilteredRowCountComponent", align: "center" },
                                        { statusPanel: "agTotalRowCountComponent", align: "right" }
                                    ]
                                }}
                                sideBar={{
                                    toolPanels: [
                                        {
                                            id: 'columns',
                                            labelDefault: 'Columns',
                                            iconKey: 'columns',
                                            toolPanel: 'agColumnsToolPanel'
                                        },
                                        {
                                            id: 'filters',
                                            labelDefault: 'Filters',
                                            iconKey: 'filter',
                                            toolPanel: 'agFiltersToolPanel'
                                        }
                                    ],
                                    // defaultToolPanel: 'filters'
                                }}
                                animateRows rowSelection={"multiple"}
                                rowHeight={45}
                                headerHeight={45}
                                frameworkComponents={this.state.frameworkComponents}
                                onSelectionChanged={() => {
                                    // if (this.gridRef && this.gridRef.current && this.gridRef.current.api) {
                                    //     const selected = this.gridRef.current.api.getSelectedRows();
                                    //     this.setState({ selectedRows: selected })
                                    // }
                                }} suppressRowClickSelection={true}
                            />
                        </div>
                    </div>
                </div>


                {/* <button className="btn btn-success" onClick={this.formAssignHandler.bind(this)} style={{marginLeft:"91em"}}>Insert Exports</button> */}
                <div className={"slide-r " + (this.state.bulkslide)} style={{ overflow: "hidden", display: "flex", flexDirection: "column", height: "100%" }}>
                    {/* Panel Header */}
                    <div style={{ background: "linear-gradient(135deg, #1565c0 0%, #1976d2 100%)", padding: "16px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <i className="icofont icofont-truck-loaded" style={{ color: "white", fontSize: "22px" }}></i>
                            <div>
                                <h5 style={{ color: "white", margin: 0, fontWeight: 700, fontSize: "15px", letterSpacing: "0.3px" }}>Plan New Dispatch</h5>
                                <p style={{ color: "rgba(255,255,255,0.75)", margin: 0, fontSize: "11px" }}>Upload demand data to run the solver</p>
                            </div>
                        </div>
                        <button type="button" onClick={this.resetUpload.bind(this)} style={{ background: "rgba(255,255,255,0.2)", border: "none", borderRadius: "50%", width: "30px", height: "30px", color: "white", cursor: "pointer", fontSize: "18px", lineHeight: "1", display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
                    </div>

                    {/* Scrollable content */}
                    <div className="slide-r-body" style={{ position: "relative", flex: 1, overflowY: "auto" }}>
                        <div style={{ padding: "20px 20px 8px 20px" }}>
                            {this.state.processErrShow == 0 ?
                                <form method="POST" id="upform" className="theme-form" onSubmit={this.uploadBulkFormHandler}>

                                    {/* Step 1 — Template */}
                                    <div style={{ background: "#e8f4fd", border: "1px solid #b3d9f7", borderRadius: "8px", padding: "14px 16px", marginBottom: "18px", display: "flex", alignItems: "center", gap: "14px" }}>
                                        <i className="icofont icofont-file-excel" style={{ color: "#1565c0", fontSize: "28px", flexShrink: 0 }}></i>
                                        <div style={{ flex: 1 }}>
                                            <p style={{ margin: "0 0 6px 0", fontWeight: 600, fontSize: "13px", color: "#1a237e" }}>Step 1 — Download Template</p>
                                            <p style={{ margin: "0 0 8px 0", fontSize: "12px", color: "#555" }}>Use the standard format to avoid upload errors.</p>
                                            {(this.state.loading_port_code == "RPDCGUR") ?
                                                <a className="btn btn-primary btn-sm" href={require('../../assets/json/input_data_template_pick_ticket.csv')} target="_blank" style={{ fontSize: "12px" }}>
                                                    <i className="icofont icofont-download-alt"></i>&nbsp;Download Template
                                                </a>
                                                :
                                                <a className="btn btn-primary btn-sm" href={require('../../assets/json/input_data_template.csv')} target="_blank" style={{ fontSize: "12px" }}>
                                                    <i className="icofont icofont-download-alt"></i>&nbsp;Download Template
                                                </a>
                                            }
                                        </div>
                                    </div>

                                    {/* Step 2 — Upload File */}
                                    <div style={{ marginBottom: "18px" }}>
                                        <p style={{ fontWeight: 600, fontSize: "13px", color: "#333", marginBottom: "8px" }}>
                                            Step 2 — Upload Demand File <span style={{ color: "#e53935" }}>*</span>
                                        </p>
                                        <label
                                            htmlFor="uploadFile"
                                            onDragOver={this.handleDragOver}
                                            onDragLeave={this.handleDragLeave}
                                            onDrop={this.handleDrop}
                                            style={{ display: "block", border: this.state.isDragging ? "2px dashed #1565c0" : "2px dashed #90caf9", borderRadius: "8px", padding: "18px 16px", textAlign: "center", background: this.state.isDragging ? "#e3f2fd" : "#fafcff", cursor: "pointer", transition: "all 0.2s" }}
                                        >
                                            <i className="icofont icofont-cloud-upload" style={{ fontSize: "30px", color: this.state.isDragging ? "#1565c0" : "#1976d2", display: "block", marginBottom: "6px", transition: "color 0.2s" }}></i>
                                            <span style={{ fontSize: "13px", color: this.state.isDragging ? "#1565c0" : "#555", fontWeight: this.state.isDragging ? 600 : 400 }}>
                                                {this.state.isDragging ? "Drop the file here" : "Click to browse or drag & drop a CSV file"}
                                            </span>
                                            <input type="file" name="uploadFile" id="uploadFile" onChange={this.changeFileHandler} required style={{ position: "absolute", width: 0, height: 0, opacity: 0, overflow: "hidden" }} />
                                        </label>

                                        {/* Selected file indicator */}
                                        {this.state.selectedFileName ? (
                                            <div style={{ display: "flex", alignItems: "center", gap: "8px", background: "#e8f5e9", border: "1px solid #a5d6a7", borderRadius: "6px", padding: "8px 12px", marginTop: "10px" }}>
                                                <i className="icofont icofont-file-excel" style={{ color: "#2e7d32", fontSize: "18px", flexShrink: 0 }}></i>
                                                <span style={{ fontSize: "13px", color: "#1b5e20", fontWeight: 600, wordBreak: "break-all" }}>{this.state.selectedFileName}</span>
                                                <span style={{ marginLeft: "auto", fontSize: "11px", color: "#388e3c" }}>Ready</span>
                                            </div>
                                        ) : (
                                            <p style={{ fontSize: "11px", color: "#aaa", textAlign: "center", marginTop: "6px", marginBottom: 0 }}>No file selected</p>
                                        )}

                                        {/* Blank rows note */}
                                        <div onClick={this.toggleMoreInfo} style={{ background: "#fffde7", border: "1px solid #ffe082", borderRadius: "6px", padding: "9px 12px", marginTop: "10px", fontSize: "12px", color: "#5d4037", cursor: "pointer" }}>
                                            <i className="icofont icofont-warning" style={{ color: "#f9a825", marginRight: "5px" }}></i>
                                            <strong>Note:</strong> Blank rows/columns are not allowed.&nbsp;
                                            <span style={{ color: "#1565c0", fontWeight: 600 }}>{this.state.showMoreInfo ? "Show less ▲" : "How to fix ▼"}</span>
                                            {this.state.showMoreInfo && (
                                                <p style={{ margin: "8px 0 0 0", lineHeight: "1.6", color: "#555" }}>
                                                    1. Click <strong>Find &amp; Select</strong> → <strong>Go to Special</strong> → <strong>Blanks</strong> → OK.<br />
                                                    2. All blank cells will be highlighted.<br />
                                                    3. Home tab → <strong>Delete</strong> → <strong>Delete Sheet Rows</strong>.
                                                </p>
                                            )}
                                        </div>
                                        <p style={{ color: "#e53935", fontSize: "11px", marginTop: "6px", marginBottom: 0 }}>
                                            * Do not rename any column headers in the template file.
                                        </p>
                                    </div>

                                    {/* Step 3 — Notify Email */}
                                    <div style={{ marginBottom: "18px" }}>
                                        <label style={{ fontWeight: 600, fontSize: "13px", color: "#333", marginBottom: "6px", display: "block" }}>
                                            Step 3 — Notify Emails After Processing
                                        </label>
                                        <textarea name="notify_email" id="notify_email" className="form-control" rows="2" placeholder="user1@example.com, user2@example.com" style={{ fontSize: "13px", resize: "vertical", borderRadius: "6px" }}></textarea>
                                    </div>

                                    {/* Options — conditional on data_type */}
                                    {this.state.data_type !== 3 &&
                                        <div style={{ marginBottom: "8px" }}>
                                            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "12px" }}>
                                                <div style={{ height: "1px", flex: 1, background: "#e0e0e0" }}></div>
                                                <span style={{ fontSize: "10px", fontWeight: 700, color: "#aaa", letterSpacing: "1.2px", textTransform: "uppercase" }}>Solver Options</span>
                                                <div style={{ height: "1px", flex: 1, background: "#e0e0e0" }}></div>
                                            </div>

                                            {/* data_type 1 — Regular / Hub */}
                                            {this.state.data_type === 1 && <>
                                                {(localStorage.getItem("email") == "moganty.venkat@enmovil.in") &&
                                                    <label htmlFor="alphaCheckkbox" style={{ display: "flex", alignItems: "center", gap: "12px", background: "#fff", border: "1.5px solid #eeeeee", borderRadius: "10px", padding: "12px 14px", marginBottom: "8px", cursor: "pointer", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
                                                        <input type="checkbox" name="alphaCheckkbox" id="alphaCheckkbox" value="1" style={{ width: "17px", height: "17px", cursor: "pointer", accentColor: "#1565c0", flexShrink: 0 }} />
                                                        <div style={{ width: "38px", height: "38px", background: "#fff3e0", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                                            <i className="icofont icofont-code-alt" style={{ color: "#e65100", fontSize: "19px" }}></i>
                                                        </div>
                                                        <div style={{ flex: 1 }}>
                                                            <div style={{ fontSize: "13px", fontWeight: 600, color: "#222" }}>Python Solver</div>
                                                            <div style={{ fontSize: "11px", color: "#999", marginTop: "2px" }}>Run optimisation using the Python engine</div>
                                                        </div>
                                                        <span style={{ fontSize: "10px", fontWeight: 700, color: "#e53935", background: "#ffeaea", padding: "2px 7px", borderRadius: "4px", letterSpacing: "0.3px", flexShrink: 0 }}>NEW</span>
                                                    </label>
                                                }
                                                {/* Run profile — mutually exclusive radio options */}
                                                <label htmlFor="manualradio" style={{ display: "flex", alignItems: "center", gap: "12px", background: "#fff", border: "1.5px solid #eeeeee", borderRadius: "10px", padding: "12px 14px", marginBottom: "8px", cursor: "pointer", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
                                                    <input type="radio" name="runProfile" id="manualradio" value="1" defaultChecked style={{ width: "17px", height: "17px", cursor: "pointer", accentColor: "#1565c0", flexShrink: 0 }} />
                                                    <div style={{ width: "38px", height: "38px", background: "#eef1f4", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                                        <i className="icofont icofont-truck-alt" style={{ color: "#546e7a", fontSize: "19px" }}></i>
                                                    </div>
                                                    <div style={{ flex: 1 }}>
                                                        <div style={{ fontSize: "13px", fontWeight: 600, color: "#222" }}>Regular (Manual)</div>
                                                        <div style={{ fontSize: "11px", color: "#999", marginTop: "2px" }}>Standard single Regular run</div>
                                                    </div>
                                                </label>
                                                <label htmlFor="automatedcheckbox" style={{ display: "flex", alignItems: "center", gap: "12px", background: "#fff", border: "1.5px solid #eeeeee", borderRadius: "10px", padding: "12px 14px", marginBottom: "8px", cursor: "pointer", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
                                                    <input type="radio" name="runProfile" id="automatedcheckbox" value="1" style={{ width: "17px", height: "17px", cursor: "pointer", accentColor: "#1565c0", flexShrink: 0 }} />
                                                    <div style={{ width: "38px", height: "38px", background: "#e8f4fd", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                                        <i className="icofont icofont-infinite" style={{ color: "#1565c0", fontSize: "19px" }}></i>
                                                    </div>
                                                    <div style={{ flex: 1 }}>
                                                        <div style={{ fontSize: "13px", fontWeight: 600, color: "#222" }}>Automated Run</div>
                                                        <div style={{ fontSize: "11px", color: "#999", marginTop: "2px" }}>Regular &rarr; Dedicated &rarr; Courier</div>
                                                    </div>
                                                    <span style={{ fontSize: "10px", fontWeight: 700, color: "#1565c0", background: "#e3f2fd", padding: "2px 7px", borderRadius: "4px", letterSpacing: "0.3px", flexShrink: 0 }}>NEW</span>
                                                </label>
                                                <label htmlFor="hubholdcheckbox" style={{ display: "flex", alignItems: "center", gap: "12px", background: "#fff", border: "1.5px solid #eeeeee", borderRadius: "10px", padding: "12px 14px", cursor: "pointer", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
                                                    <input type="radio" name="runProfile" id="hubholdcheckbox" value="1" style={{ width: "17px", height: "17px", cursor: "pointer", accentColor: "#1565c0", flexShrink: 0 }} />
                                                    <div style={{ width: "38px", height: "38px", background: "#fff8e1", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                                        <i className="icofont icofont-network-tower" style={{ color: "#f9a825", fontSize: "19px" }}></i>
                                                    </div>
                                                    <div style={{ flex: 1 }}>
                                                        <div style={{ fontSize: "13px", fontWeight: 600, color: "#222" }}>Regular + Hub Hold</div>
                                                        <div style={{ fontSize: "11px", color: "#999", marginTop: "2px" }}>Regular run; unserved hub dealers held as HUB HOLD</div>
                                                    </div>
                                                    <span style={{ fontSize: "10px", fontWeight: 700, color: "#f9a825", background: "#fff8e1", padding: "2px 7px", borderRadius: "4px", letterSpacing: "0.3px", flexShrink: 0 }}>NEW</span>
                                                </label>
                                            </>}

                                            {/* data_type 2 — Surface Courier */}
                                            {this.state.data_type === 2 &&
                                                <label htmlFor="vipcheckbox" style={{ display: "flex", alignItems: "center", gap: "12px", background: "#fff", border: "1.5px solid #eeeeee", borderRadius: "10px", padding: "12px 14px", cursor: "pointer", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
                                                    <input type="checkbox" name="vipcheckbox" id="vipcheckbox" value="1" style={{ width: "17px", height: "17px", cursor: "pointer", accentColor: "#6a1b9a", flexShrink: 0 }} />
                                                    <div style={{ width: "38px", height: "38px", background: "#f3e5f5", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                                        <i className="icofont icofont-diamond" style={{ color: "#6a1b9a", fontSize: "19px" }}></i>
                                                    </div>
                                                    <div style={{ flex: 1 }}>
                                                        <div style={{ fontSize: "13px", fontWeight: 600, color: "#222" }}>VIP Order Planning</div>
                                                        <div style={{ fontSize: "11px", color: "#999", marginTop: "2px" }}>Enable priority planning for VIP orders</div>
                                                    </div>
                                                    <span style={{ fontSize: "10px", fontWeight: 700, color: "#6a1b9a", background: "#f3e5f5", padding: "2px 7px", borderRadius: "4px", letterSpacing: "0.3px", flexShrink: 0 }}>VIP</span>
                                                </label>
                                            }

                                            {/* Hidden legacy checkboxes — still read by form handler */}
                                            <input type="checkbox" name="betaChechkbox" id="betaChechkbox" value="1" style={{ display: "none" }} />
                                            <input type="checkbox" name="deltacheckbox" id="deltacheckbox" value="1" style={{ display: "none" }} />
                                        </div>
                                    }
                                </form>
                                :
                                /* Error State */
                                <div>
                                    <div style={{ background: "#fff3f3", border: "1px solid #ffcdd2", borderRadius: "8px", padding: "14px 16px", marginBottom: "16px", display: "flex", gap: "12px", alignItems: "flex-start" }}>
                                        <i className="icofont icofont-warning-alt" style={{ color: "#e53935", fontSize: "22px", flexShrink: 0, marginTop: "1px" }}></i>
                                        <p style={{ margin: 0, fontSize: "13px", color: "#c62828", lineHeight: "1.6" }}>{this.state.processErrMsg}</p>
                                    </div>

                                    {this.state.droppedList.length > 0 &&
                                        <div style={{ marginBottom: "16px" }}>
                                            <p style={{ fontWeight: 600, fontSize: "13px", color: "#333", marginBottom: "8px" }}>
                                                <i className="icofont icofont-list"></i>&nbsp;Dropped Dealers
                                            </p>
                                            <div id="myGrid" style={{ width: "100%", height: "260px" }} className={"ag-theme-balham " + this.state.showGridData}>
                                                <AgGridReact
                                                    modules={this.state.modules}
                                                    columnDefs={columnwithDefsForDropped}
                                                    defaultColDef={this.state.defaultColDef}
                                                    rowData={this.state.droppedList}
                                                    enableCharts={false}
                                                    onGridReady={this.onGridReady}
                                                    onGridState={this.onGridState}
                                                    frameworkComponents={this.state.frameworkComponents}
                                                    statusBar={this.state.statusBar}
                                                    sideBar={this.state.sideBar}
                                                    stopEditingWhenGridLosesFocus={true}
                                                    paginationPageSize={this.state.paginationPageSize}
                                                    pagination={false}
                                                    gridOptions={{ context: { componentParent: this } }}
                                                    enableRangeSelection={true}
                                                    rowHeight={45}
                                                    headerHeight={45}
                                                />
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>

                    {/* Fixed footer — buttons always visible at bottom */}
                    <div style={{ flexShrink: 0, borderTop: "1px solid #e8e8e8", padding: "14px 20px", background: "#fff" }}>
                        <div id="inValidDataInfo" style={{ display: "none", background: "#fff8f8", border: "1px solid #ffcdd2", borderRadius: "8px", overflowY: "auto", maxHeight: "250px", marginBottom: "10px" }}></div>
                        {this.state.processErrShow == 0 ?
                            <div style={{ display: "flex", gap: "10px" }}>
                                <span
                                    title={!this.state.selectedFileName ? "Please upload a file to generate" : this.state.flag === 1 ? "Fix validation errors before generating" : ""}
                                    style={{ flex: 1, display: "flex", cursor: (!this.state.selectedFileName || this.state.flag === 1) ? "not-allowed" : "default" }}
                                >
                                    <button
                                        type="submit"
                                        form="upform"
                                        id="generateLoadBtn"
                                        className={"btn " + (this.state.selectedFileName && this.state.flag === 0 ? "btn-success" : "btn-default")}
                                        disabled={!this.state.selectedFileName || this.state.flag === 1}
                                        style={{ flex: 1, fontWeight: 600, fontSize: "14px", borderRadius: "6px", height: "42px", display: "flex", alignItems: "center", justifyContent: "center", gap: "6px", pointerEvents: (!this.state.selectedFileName || this.state.flag === 1) ? "none" : "auto", opacity: (!this.state.selectedFileName || this.state.flag === 1) ? 0.55 : 1 }}
                                    >
                                        <i className="icofont icofont-rocket-alt-2"></i> Generate Load
                                    </button>
                                </span>
                                <button type="button" onClick={this.resetUpload.bind(this)} className="btn btn-default" style={{ flex: 1, fontSize: "14px", borderRadius: "6px", height: "42px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    Cancel
                                </button>
                            </div>
                            :
                            <div style={{ display: "flex", gap: "10px" }}>
                                <button type="button" onClick={this.fixProcess.bind(this)} className="btn btn-success" style={{ flex: 1, fontWeight: 600, fontSize: "14px", borderRadius: "6px", height: "42px", display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
                                    <i className="icofont icofont-fix-tools"></i> Fix &amp; Reupload
                                </button>
                                {this.state.statusCode == 11 ?
                                    <button type="button" onClick={this.resetUpload.bind(this)} className="btn btn-default" style={{ flex: 1, fontSize: "14px", borderRadius: "6px", height: "42px", display: "flex", alignItems: "center", justifyContent: "center" }}>Cancel</button>
                                    :
                                    <button type="button" onClick={this.ignoreProcessError.bind(this)} className="btn btn-default" style={{ flex: 1, fontSize: "14px", borderRadius: "6px", height: "42px", display: "flex", alignItems: "center", justifyContent: "center" }}>Ignore &amp; Continue</button>
                                }
                            </div>
                        }
                    </div>
                    {this.state.isGeneratingLoad &&
                        <div style={{ position: "absolute", inset: 0, background: "rgba(255,255,255,0.75)", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "10px", zIndex: 10, cursor: "wait" }}>
                            <div className="loader-box"><div className="rotate dashed colored"></div></div>
                            <span style={{ fontSize: "13px", fontWeight: 600, color: "#1565c0" }}>Generating load, please wait...</span>
                        </div>
                    }
                </div>
                <div className={"dataLoadpage " + (this.state.loadshow)}>
                </div>
                <div className={"dataLoadpageimg " + (this.state.loadshow)}>
                    <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
                </div>
                <div className={"overlay-part " + (this.state.overly)} onClick={this.onClickHideAll.bind(this)}></div>
            </div>

        );
    }
}

function dateComparator1(date1, date2) {
    //console.log(date1,date2);
    if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
        // console.log(date1,date2);
        var date_1 = getMonthNumber(date1.split("-")[1]);
        date1 = date1.replace(date1.split("-")[1], date_1);
        var date_2 = getMonthNumber(date2.split("-")[1]);
        date2 = date2.replace(date2.split("-")[1], date_2);
        var date1Number = monthToComparableNumber1(date1);
        var date2Number = monthToComparableNumber1(date2);
        if (date1Number === null && date2Number === null) {
            return 0;
        }
        if (date1Number === null) {
            return -1;
        }
        if (date2Number === null) {
            return 1;
        }
        return date1Number - date2Number;
    }
}

function monthToComparableNumber1(date) {
    console.log(date.length);
    console.log(date);
    if (date === undefined || date === null || date.length !== 10) {
        return null;
    }
    var yearNumber = date.substring(6, 10);
    var monthNumber = date.substring(3, 5);
    var dayNumber = date.substring(0, 2);
    var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
    return result;
}
function dateComparator(date1, date2) {
    // console.log("dateComparator");
    // console.log(date1.length);
    if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
        // console.log(date1,date2);
        var date_1 = getMonthNumber(date1.split(" ")[0].split("-")[1]);
        date1 = date1.replace(date1.split(" ")[0].split("-")[1], date_1);
        var date_2 = getMonthNumber(date2.split(" ")[0].split("-")[1]);
        date2 = date2.replace(date2.split(" ")[0].split("-")[1], date_2);
        // console.log(date1,date2);
        var date1Number = monthToComparableNumber(date1);
        var date2Number = monthToComparableNumber(date2);
        // console.log(date1Number,date2Number);
        if (date1Number === null && date2Number === null) {
            return 0;
        }
        if (date1Number === null) {
            return -1;
        }
        if (date2Number === null) {
            return 1;
        }
        return date1Number - date2Number;
    }
}
function monthToComparableNumber(date) {
    // console.log(date,date.length);
    if (date === undefined || date === null || date.length !== 16) {
        return null;
    }
    var yearNumber = date.substring(6, 10);
    var monthNumber = date.substring(3, 5);
    var dayNumber = date.substring(0, 2);
    console.log(yearNumber, monthNumber, dayNumber);
    var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
    return result;
}

function getMonthNumber(monthName) {
    var months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May',
        'Jun', 'Jul', 'Aug', 'Sep',
        'Oct', 'Nov', 'Dec'
    ];
    var monthNum = months.indexOf(monthName) + 1;
    if (monthNum < 10) {
        monthNum = "0" + monthNum.toString();
    }
    return monthNum;
}


function loadDateTimeScript() {
    // alert("timeDate");
    $('.datetimepicker_mask').datetimepicker({
        //mask:'39-19-9999 29:59',
        format: 'd-m-Y'
    });
    $('.datetimepicker_date').datetimepicker({
        mask: '39-19-9999',
        format: 'd-m-Y',
        timepicker: false
    });
    var index = window.document.getElementsByTagName("script")[1]
    var script = window.document.createElement("script")
    script.src = "https://www.jqueryscript.net/demo/Clean-jQuery-Date-Time-Picker-Plugin-datetimepicker/jquery.datetimepicker.js"
    //script.src="http://xdsoft.net/jqplugins/datetimepicker/"
    script.async = true
    script.defer = true
    index.parentNode.insertBefore(script, index)
}

function DateEditor() { }

// gets called once before the renderer is used
DateEditor.prototype.init = function (params) {
    // create the cell
    this.eInput = document.createElement('input');
    this.eInput.value = params.value;

    // https://jqueryui.com/datepicker/
    $(this.eInput).datetimepicker({
        dateFormat: "yy-mm-dd",
        changeMonth: true,
        changeYear: true,
        timepicker: false,
    });
};

// gets called once when grid ready to insert the element
DateEditor.prototype.getGui = function () {
    return this.eInput;
};

// focus and select can be done after the gui is attached
DateEditor.prototype.afterGuiAttached = function () {
    this.eInput.focus();
    this.eInput.select();
};

// returns the new value after editing
DateEditor.prototype.getValue = function () {
    // console.log(this.eInput.value);
    return this.eInput.value;
};

// any cleanup we need to be done here
DateEditor.prototype.destroy = function () {
    // but this example is simple, no cleanup, we could
    // even leave this method out as it's optional
};

// if true, then this editor will appear in a popup
DateEditor.prototype.isPopup = function () {
    // and we could leave this method out also, false is the default
    return false;
};